import * as React from 'react'
import { formatCurrencyDisplay } from '@/lib/utils'

interface CurrencyValueProps {
  value: number
  className?: string
}

/**
 * CurrencyValue component that displays currency values with special handling for small values.
 * When a value is greater than 0 but less than $0.01 (would display as "$0.00"),
 * it shows "<$0.01" with a tooltip revealing the actual value on hover.
 */
export function CurrencyValue({ value, className }: CurrencyValueProps) {
  const { display } = formatCurrencyDisplay(value)
  return <span className={className}>{display}</span>
}

/**
 * Hook version for cases where you need the formatted value as a string
 * Returns { display, renderWithTooltip }
 */
export function useCurrencyValue(value: number) {
  const result = formatCurrencyDisplay(value)

  const renderWithTooltip = React.useCallback(
    (className?: string) => {
      return <span className={className}>{result.display}</span>
    },
    [result.display]
  )

  return {
    ...result,
    renderWithTooltip,
  }
}

